// packages/content/src/catalog/tools.ts (M1-T01, §7.3)
import type { CatalogEntry } from '../schema/catalog';
export default [
  { id: 'tool.rod', kind: 'tool', name: 'items.rod', sell: 125, stack: 1, buy: 500, tool: 'rod' },
  { id: 'tool.shovel', kind: 'tool', name: 'items.shovel', sell: 150, stack: 1, buy: 600, tool: 'shovel' },
] as const satisfies readonly CatalogEntry[];
